import '@splidejs/splide/css';
import { Splide } from "@splidejs/splide";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

window["Splide"] = Splide;
window['gsap'] = gsap;
window['ScrollTrigger'] = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);